export const formatDutchDate = (dateString) => {
  if (!dateString || typeof dateString !== "string") {
    console.error("Invalid date string:", dateString);
    return null;
  }

  const monthMap = {
    januari: 0,
    februari: 1,
    maart: 2,
    april: 3,
    mei: 4,
    juni: 5,
    juli: 6,
    augustus: 7,
    september: 8,
    oktober: 9,
    november: 10,
    december: 11,
  };

  const [day, month, year] = dateString.trim().split(/\s+/);
  const cleanMonth = month.toLowerCase().trim();
  const monthIndex = monthMap[cleanMonth];

  if (!monthIndex && monthIndex !== 0) {
    console.error("Invalid month:", month);
    return null;
  }

  const dateObj = new Date(parseInt(year), monthIndex, parseInt(day));

  const dayNames = [
    "Zondag",
    "Maandag",
    "Dinsdag",
    "Woensdag",
    "Donderdag",
    "Vrijdag",
    "Zaterdag",
  ];

  const formattedDay = dayNames[dateObj.getDay()];
  const formattedDate = `${formattedDay}, ${day} ${month}`;

  return formattedDate;
};
